<footer class="footer-section mt-0">
    <div class="container">
        <div class="row pt-5 m-0">
            <!--            <div class="columnFoot column-medium-6">
                <div class="css-bjprmd"><a class="css-1xyh8em"><img style="height: 60px;"
                            src="./assets/images/SingX_w_logo.png" alt="Footer Logo" id="logo"></a></div>
                <div class="mt-3">
                    <ul>
                        <li><a>Terms of use</a></li>
                        <li><a>Privacy</a></li>
                    </ul>
                </div>
                <p class="mt-3">&copy; 2021 SingX Pte Ltd
                </p>
            </div>-->
            <div class="columnFoot column-medium-6">
                <h4 class="css-poaal3">Solutions</h4>
                <ul>
                    <li><a [class.text-orange]="country == 'sg'" (click)="switchCountry('sg')">Singapore</a></li>
                    <li><a [class.text-orange]="country == 'hk'" (click)="switchCountry('hk')">Hong Kong</a></li>
                    <li><a [class.text-orange]="country == 'au'" (click)="switchCountry('au')">Australia</a></li>
                    <li><a href="https://business.singx.co/">Business</a></li>
                </ul>
            </div>
            <div class="columnFoot column-medium-6">
                <h4 class="css-poaal3">Company</h4>
                <ul>
                    <li><a routerLink="/aboutus">About</a></li>
                    <li><a routerLink="/licenses">Licenses</a></li>
                    <li><a routerLink="/team">Team</a></li>
                    <li><a routerLink="/faq">FAQ</a></li>
                </ul>
            </div>
            <div class="columnFoot column-medium-6">
                <h4 class="css-poaal3">Information</h4>
                <ul>
                    <li><a routerLink="/contact-us">Contact Us</a></li>
                    <li><a routerLink="/terms-of-use">Terms of Use</a></li>
                    <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    <li class="financial-services" *ngIf="country == 'au'"><a class="product"
                            routerLink="/financialservices">Financial Services Guide</a></li>
                    <li class="financial-services" *ngIf="country == 'au'"><a class="product"
                            routerLink="/productdisclosure">Product Disclosure Statement</a></li>
                </ul>
            </div>
            <div class="columnFoot column-medium-6">
                <h4 class="css-poaal3">Connect</h4>
                <ul>
                    <li><i class="fab fa-facebook-square mr-1 fa-lg" style="color:#4267B2;"></i><a class="css-nxq3wi"
                            href="https://www.facebook.com/singx.co/" rel="noreferrer" target="_blank">Facebook</a></li>
                    <li><i class="fab fa-linkedin mr-1 fa-lg" style="color:#0e76a8;"></i><a class="css-nxq3wi"
                            href="https://www.linkedin.com/company/singx" rel="noreferrer" target="_blank">Linkedin</a>
                    </li>
                    <li><i class="fab fa-youtube-square mr-1 fa-lg" style="color:#FF0000"></i><a class="css-nxq3wi"
                            href="https://www.youtube.com/channel/UCbqejoxNBQAcTzGPMGD_knw" rel="noreferrer"
                            target="_blank">Youtube</a></li>
                </ul>
            </div>
        </div>
        <div class="row m-0">
            <span class="text-center text-white font_inter" *ngIf="country == 'sg'">*SingX Pte Ltd is a company registered in
                Singapore (UEN: 201433979Z) and works with licensed remittance
                operators in each country. In Singapore, SingX works with our group company, SingX Singapore Pte Ltd
                (UEN:
                201533243W) which is regulated as a remittance business (License number PS20200369) by The Monetary
                Authority of Singapore (MAS). For a list of licenses in all countries, <a routerLink="/licenses">please
                    click here</a>. © 2021 SingX Pte Ltd. All rights reserved.</span>
            <!-- hong kong -->
            <span class="text-center text-white font_inter" *ngIf="country == 'hk'">*SingX Pte Ltd is a company registered in
                Singapore (UEN: 201433979Z) and works with licensed remittance operators in each country.
                In Hong Kong, SingX works with our group company, SingX Hong Kong Co. Ltd (License number 16-09-01908)
                which is regulated as a remittance business by Customs and Excise office in Hong Kong.
                For a list of licenses in all countries, click here. © 2022 SingX Pte Ltd. All rights reserved.
            </span>
            <!-- end hongkong -->
            <span class="text-center text-white font_inter" *ngIf="country == 'au'">*SingX Pte Ltd is a company registered in
                Singapore (UEN: 201433979Z) and works with licensed remittance operators in each country.
                Pursuant to section 75C (2) of the Australian Anti-Money Laundering and Counter-Terrorism Financing Act
                2006 (AML/CTF Act), SingX Australia Pty Ltd has been registered as a Remittance Provider on
                the Remittance Sector Register (RSR) of Australian Transaction Reports and Analysis Centre (AUSTRAC).
                <br> <br>
                In Australia, SingX Pte Ltd. works with its group company, SingX Australia Pty Ltd (ACN: 624277201)
                which is regulated as an Australian Financial Services Licence (AFSL) (License number 508309) by
                Australian Securities & Investments Commission (ASIC).
            </span>
            <div class="col-12 mb-3"></div>
        </div>
    </div>
</footer>